import $ from 'jquery';
import { FormFileUpload, FormSelect } from '@/components/form/elements';
import { FormContact } from '@/components/form/form-contact';
class JobSelector {
    constructor($jobSelector = $('#job-selector'), $jobSelectorContent = $('#job-selector-content')) {
        this.$jobSelector = $jobSelector;
        this.$jobSelectorContent = $jobSelectorContent;
        if (this.$jobSelector.length === 0)
            return;
        this.selectJob();
    }
    selectJob() {
        this.$jobSelector.on('change', (event) => {
            const vacancy = event.target.value;
            this.$jobSelectorContent.empty();
            if (!vacancy)
                return;
            $.ajax({
                url: `/vacancies/${vacancy}`,
                method: "GET",
                success: (res) => {
                    const content = document.createElement('div');
                    content.innerHTML = `
            <h2>${res.title}</h2>

            ${res.description ?
                        `<div class="text-base">${res.description}</div>`
                        : ''}
            
            <div>
              <h3>Responsibilites: </h3>
              <ul class="list-disc pl-4 text-base">
                ${res.responsibilities.map((responbility) => (`<li>${responbility}</li>`)).join('')}
              </ul>
            </div>

            <div>
              <h3>Requirements: </h3>
              <ul class="list-disc pl-4 text-base">
                ${res.requirements.map((requirement) => (`<li>${requirement}</li>`)).join('')}
              </ul>
            </div>
          `;
                    this.$jobSelectorContent.append(content);
                },
                error: (error) => {
                    let message = 'Unexpected error, please try again';
                    const content = document.createElement('div');
                    content.classList.add('alert', 'is-outline', 'is-info', '!mt-0');
                    if (error.responseJSON) {
                        message = error.responseJSON.message;
                    }
                    content.innerHTML = `
            <i class="icon-exclamation-solid"></i>
            ${message}
          `;
                    this.$jobSelectorContent.append(content);
                }
            });
        });
    }
}
new FormSelect();
new FormFileUpload();
new FormContact();
new JobSelector();
